export default {
  // Common
  'common.codeExample': 'Code Example',
  'common.tryItYourself': 'Try it yourself',
  'common.output': 'Output',
  'common.explanation': 'Explanation',
  'common.bestPractices': 'Best Practices',
  'common.commonMistakes': 'Common Mistakes',
  'common.relatedFunctions': 'Related Functions',

  // MySQL Timestamp Page
  'mysql.mainTitle': 'MySQL Timestamp Complete Guide',
  'mysql.mainTitleSEO': 'MySQL Timestamp Tutorial - UNIX_TIMESTAMP & FROM_UNIXTIME Guide',
  'mysql.subtitle': 'Master MySQL timestamp functions, data types, and timezone handling',

  'mysql.intro': 'MySQL provides powerful functions for working with Unix timestamps. This guide covers everything from basic timestamp functions to advanced timezone handling.',

  // UNIX_TIMESTAMP() Section
  'mysql.unixTimestampTitle': 'UNIX_TIMESTAMP() Function',
  'mysql.unixTimestampDesc': 'Converts a date/datetime to Unix timestamp (seconds since 1970-01-01 00:00:00 UTC)',
  'mysql.getCurrentTimestamp': 'Get Current Unix Timestamp',
  'mysql.convertDateToTimestamp': 'Convert Date to Timestamp',
  'mysql.example1': 'Returns current Unix timestamp in seconds',
  'mysql.example2': 'Convert specific datetime to timestamp',

  // FROM_UNIXTIME() Section
  'mysql.fromUnixtimeTitle': 'FROM_UNIXTIME() Function',
  'mysql.fromUnixtimeDesc': 'Converts Unix timestamp to MySQL datetime format',
  'mysql.convertTimestampToDate': 'Convert Timestamp to Datetime',
  'mysql.formatTimestamp': 'Format Timestamp with Custom Pattern',

  // TIMESTAMP vs DATETIME
  'mysql.typesTitle': 'TIMESTAMP vs DATETIME Data Types',
  'mysql.timestampType': 'TIMESTAMP Type',
  'mysql.timestampFeature1': 'Range: 1970-01-01 to 2038-01-19',
  'mysql.timestampFeature2': 'Stored in UTC, converted to local timezone',
  'mysql.timestampFeature3': 'Automatically updates on INSERT/UPDATE',
  'mysql.timestampFeature4': 'Uses 4 bytes of storage',

  'mysql.datetimeType': 'DATETIME Type',
  'mysql.datetimeFeature1': 'Range: 1000-01-01 to 9999-12-31',
  'mysql.datetimeFeature2': 'Stored as-is, no timezone conversion',
  'mysql.datetimeFeature3': 'Manually updated',
  'mysql.datetimeFeature4': 'Uses 8 bytes of storage',

  // Practical Examples
  'mysql.practicalTitle': 'Practical SQL Examples',
  'mysql.example.insert': 'Insert Current Timestamp',
  'mysql.example.query': 'Query Records by Timestamp Range',
  'mysql.example.update': 'Update Timestamp Column',
  'mysql.example.aggregation': 'Timestamp Aggregation',

  // Timezone Handling
  'mysql.timezoneTitle': 'Timezone Handling in MySQL',
  'mysql.timezoneDesc': 'MySQL stores TIMESTAMP values in UTC and converts them to the connection timezone',
  'mysql.setTimezone': 'Set Session Timezone',
  'mysql.convertTimezone': 'Convert Between Timezones',

  // Common Use Cases
  'mysql.useCasesTitle': 'Common Use Cases',
  'mysql.useCase1.title': 'Track Record Creation Time',
  'mysql.useCase1.desc': 'Use DEFAULT CURRENT_TIMESTAMP to automatically set creation time',

  'mysql.useCase2.title': 'Track Last Update Time',
  'mysql.useCase2.desc': 'Use ON UPDATE CURRENT_TIMESTAMP to automatically update modification time',

  'mysql.useCase3.title': 'Filter by Date Range',
  'mysql.useCase3.desc': 'Use UNIX_TIMESTAMP() to filter records by timestamp range',

  'mysql.useCase4.title': 'Group by Time Period',
  'mysql.useCase4.desc': 'Use FROM_UNIXTIME() with DATE_FORMAT() to group records',

  // Performance Tips
  'mysql.performanceTitle': 'Performance Optimization Tips',
  'mysql.perf1': 'Index timestamp columns used in WHERE clauses',
  'mysql.perf2': 'Use TIMESTAMP for columns that need timezone conversion',
  'mysql.perf3': 'Use DATETIME for historical dates outside TIMESTAMP range',
  'mysql.perf4': 'Avoid using functions in WHERE clauses - use indexed columns',

  // FAQ
  'mysql.faq.q1': 'What is the Year 2038 Problem in MySQL?',
  'mysql.faq.a1': 'TIMESTAMP uses a signed 32-bit integer, which will overflow on January 19, 2038. Use DATETIME for dates beyond 2038.',

  'mysql.faq.q2': 'How to store milliseconds in MySQL?',
  'mysql.faq.a2': 'Use BIGINT to store Unix timestamp in milliseconds, or DATETIME(3) for datetime with millisecond precision.',

  'mysql.faq.q3': 'Should I use TIMESTAMP or DATETIME?',
  'mysql.faq.a3': 'Use TIMESTAMP for recent dates with timezone awareness. Use DATETIME for historical dates or when timezone conversion is not needed.',

  'mysql.faq.q4': 'How to handle timezone in MySQL?',
  'mysql.faq.a4': 'Store all timestamps in UTC using TIMESTAMP type, then convert to local timezone when displaying.',

  // Python Timestamp Page
  'python.mainTitle': 'Python Timestamp Complete Guide',
  'python.mainTitleSEO': 'Python Timestamp Tutorial - datetime, time, calendar Module Guide',
  'python.subtitle': 'Master Python timestamp handling with datetime, time, and calendar modules',

  'python.intro': 'Python provides multiple modules for working with timestamps. This comprehensive guide covers time, datetime, calendar, and timezone handling.',

  // Get Current Timestamp
  'python.getCurrentTitle': 'Get Current Unix Timestamp',
  'python.getCurrentDesc': 'Multiple ways to get current Unix timestamp in Python',
  'python.method1': 'Using time.time() - Returns float',
  'python.method2': 'Using datetime.now() - Returns integer',
  'python.method3': 'Using calendar module',

  // Convert Timestamp to Datetime
  'python.toDatetimeTitle': 'Convert Timestamp to Datetime',
  'python.toDatetimeDesc': 'Convert Unix timestamp to Python datetime object',
  'python.fromTimestamp': 'Using datetime.fromtimestamp()',
  'python.formatDatetime': 'Format Datetime String',
  'python.timezoneAware': 'Timezone-aware Datetime',

  // Convert Datetime to Timestamp
  'python.toTimestampTitle': 'Convert Datetime to Timestamp',
  'python.toTimestampDesc': 'Convert Python datetime object to Unix timestamp',
  'python.usingTimestamp': 'Using .timestamp() method',
  'python.usingMktime': 'Using time.mktime()',

  // Timezone Handling
  'python.timezoneTitle': 'Timezone Handling',
  'python.timezoneDesc': 'Working with timezones using pytz and zoneinfo',
  'python.pytzExample': 'Using pytz library',
  'python.zoneinfoExample': 'Using zoneinfo (Python 3.9+)',

  // Common Patterns
  'python.patternsTitle': 'Common Patterns & Use Cases',
  'python.pattern1.title': 'Timestamp Arithmetic',
  'python.pattern1.desc': 'Add or subtract time from timestamps',

  'python.pattern2.title': 'Compare Timestamps',
  'python.pattern2.desc': 'Compare two timestamps to find time difference',

  'python.pattern3.title': 'Round Timestamps',
  'python.pattern3.desc': 'Round timestamp to nearest day/hour/minute',

  'python.pattern4.title': 'Parse String to Timestamp',
  'python.pattern4.desc': 'Convert date string to timestamp',

  // JavaScript Timestamp Page
  'javascript.mainTitle': 'JavaScript Timestamp Complete Guide',
  'javascript.mainTitleSEO': 'JavaScript Timestamp Tutorial - Date Object & Methods Guide',
  'javascript.subtitle': 'Master JavaScript Date object, timestamp methods, and timezone handling',

  'javascript.intro': 'JavaScript provides the Date object for working with timestamps. This guide covers everything from basic methods to advanced timezone handling.',

  // Get Current Timestamp
  'javascript.getCurrentTitle': 'Get Current Unix Timestamp',
  'javascript.getCurrentDesc': 'Multiple ways to get current timestamp in JavaScript',
  'javascript.dateNow': 'Using Date.now() - Most efficient',
  'javascript.getTime': 'Using new Date().getTime()',
  'javascript.valueOf': 'Using valueOf() method',
  'javascript.unaryPlus': 'Using unary + operator',

  // Convert Timestamp to Date
  'javascript.toDateTitle': 'Convert Timestamp to Date',
  'javascript.toDateDesc': 'Convert Unix timestamp to JavaScript Date object',
  'javascript.newDate': 'Create Date from timestamp',
  'javascript.formatDate': 'Format Date String',
  'javascript.toLocaleString': 'Using toLocaleString() for formatting',

  // Convert Date to Timestamp
  'javascript.toTimestampTitle': 'Convert Date to Timestamp',
  'javascript.toTimestampDesc': 'Convert JavaScript Date to Unix timestamp',
  'javascript.parseDate': 'Parse date string to timestamp',
  'javascript.dateComponents': 'Create timestamp from components',

  // Date Libraries
  'javascript.librariesTitle': 'Popular Date Libraries',
  'javascript.momentJs': 'Moment.js (Legacy)',
  'javascript.dayJs': 'Day.js (Lightweight)',
  'javascript.dateFns': 'date-fns (Modern)',
  'javascript.luxon': 'Luxon (Timezone-aware)',

  // Java & PHP - Similar structure
  'java.mainTitle': 'Java Timestamp Complete Guide',
  'java.mainTitleSEO': 'Java Timestamp Tutorial - Date, Calendar, Instant Guide',
  'java.subtitle': 'Master Java timestamp handling with Date, Calendar, Instant, and LocalDateTime',
  'java.intro': 'Java provides multiple APIs for working with timestamps. This guide covers legacy Date/Calendar classes and modern java.time API (Java 8+).',

  // Get Current Timestamp
  'java.getCurrentTitle': 'Get Current Unix Timestamp',
  'java.getCurrentDesc': 'Multiple ways to get current timestamp in Java',
  'java.method1': 'Using System.currentTimeMillis() - Fastest',
  'java.method2': 'Using Instant.now() - Modern (Java 8+)',
  'java.method3': 'Using Date class - Legacy',

  // Convert Timestamp to Date
  'java.toDateTitle': 'Convert Timestamp to Date',
  'java.toDateDesc': 'Convert Unix timestamp to Java Date/Instant/LocalDateTime',
  'java.fromTimestamp': 'Using Instant.ofEpochSecond()',
  'java.toLocalDateTime': 'Convert to LocalDateTime',
  'java.formatDate': 'Format with DateTimeFormatter',

  // Convert Date to Timestamp
  'java.toTimestampTitle': 'Convert Date to Timestamp',
  'java.toTimestampDesc': 'Convert Java Date/Instant/LocalDateTime to Unix timestamp',
  'java.dateToTimestamp': 'Using Date.getTime()',
  'java.instantToTimestamp': 'Using Instant methods',

  // Timezone Handling
  'java.timezoneTitle': 'Timezone Handling',
  'java.timezoneDesc': 'Working with timezones using ZoneId and ZonedDateTime',
  'java.zoneIdExample': 'Using ZoneId',
  'java.zonedDateTimeExample': 'Using ZonedDateTime',

  // Common Patterns
  'java.patternsTitle': 'Common Java Timestamp Patterns',
  'java.pattern1.title': 'Date Arithmetic',
  'java.pattern1.desc': 'Add or subtract time using Duration and Period',
  'java.pattern2.title': 'Parse Date String',
  'java.pattern2.desc': 'Parse string to timestamp using DateTimeFormatter',
  'java.pattern3.title': 'Compare Timestamps',
  'java.pattern3.desc': 'Compare dates and calculate differences',

  'php.mainTitle': 'PHP Timestamp Complete Guide',
  'php.mainTitleSEO': 'PHP Timestamp Tutorial - time(), strtotime(), DateTime Guide',
  'php.subtitle': 'Master PHP timestamp handling with time(), date(), strtotime(), and DateTime class',
  'php.intro': 'PHP provides powerful functions for working with timestamps. This guide covers both procedural functions and object-oriented DateTime class.',

  // Get Current Timestamp
  'php.getCurrentTitle': 'Get Current Unix Timestamp',
  'php.getCurrentDesc': 'Multiple ways to get current timestamp in PHP',
  'php.method1': 'Using time() - Most common',
  'php.method2': 'Using microtime() - With microseconds',
  'php.method3': 'Using DateTime class',

  // Convert Timestamp to Date
  'php.toDateTitle': 'Convert Timestamp to Date',
  'php.toDateDesc': 'Convert Unix timestamp to formatted date string',
  'php.dateFunction': 'Using date() function',
  'php.dateTimeClass': 'Using DateTime class',
  'php.formatDate': 'Custom date formatting',

  // Convert Date to Timestamp
  'php.toTimestampTitle': 'Convert Date to Timestamp',
  'php.toTimestampDesc': 'Convert date string to Unix timestamp',
  'php.strtotime': 'Using strtotime() - Parse English text',
  'php.dateTimeToTimestamp': 'Using DateTime::getTimestamp()',

  // Timezone Handling
  'php.timezoneTitle': 'Timezone Handling',
  'php.timezoneDesc': 'Working with timezones using DateTimeZone',
  'php.setTimezone': 'Set default timezone',
  'php.dateTimeZone': 'Using DateTimeZone class',

  // Common Patterns
  'php.patternsTitle': 'Common PHP Timestamp Patterns',
  'php.pattern1.title': 'Date Arithmetic',
  'php.pattern1.desc': 'Add or subtract time using strtotime() or DateInterval',
  'php.pattern2.title': 'Parse Relative Dates',
  'php.pattern2.desc': 'Parse "next Monday", "last week", etc.',
  'php.pattern3.title': 'Compare Timestamps',
  'php.pattern3.desc': 'Compare dates and calculate differences',

  // SQL Timestamp Page (Universal - MySQL, PostgreSQL, Oracle, SQL Server)
  'sql.mainTitle': 'SQL Timestamp Complete Guide',
  'sql.mainTitleSEO': 'SQL Timestamp Tutorial - MySQL, PostgreSQL, Oracle, SQL Server',
  'sql.subtitle': 'Master timestamp handling across MySQL, PostgreSQL, Oracle, and SQL Server databases',

  'sql.intro': 'Working with Unix timestamps varies across different SQL databases. This comprehensive guide covers timestamp functions for MySQL, PostgreSQL, Oracle, and SQL Server, helping you convert between Unix timestamps and database datetime formats.',

  // Database Selection
  'sql.selectDatabase': 'Select Your Database',

  // Comparison
  'sql.comparisonTitle': 'Quick Reference: Timestamp Functions Across Databases',

  // Common Use Cases
  'sql.commonUseCases': 'Common Use Cases Across All Databases',
  'sql.useCase1.title': 'Store Creation Timestamps',
  'sql.useCase1.desc': 'Automatically track when records are created using default timestamp values',
  'sql.useCase2.title': 'Track Last Update Time',
  'sql.useCase2.desc': 'Automatically update modification timestamps when records change',
  'sql.useCase3.title': 'Filter by Date Range',
  'sql.useCase3.desc': 'Query records within specific timestamp ranges for analytics and reporting',
  'sql.useCase4.title': 'Group by Time Period',
  'sql.useCase4.desc': 'Aggregate data by hour, day, month, or year using timestamp functions',

  // Best Practices
  'sql.bestPractice1': 'Always store timestamps in UTC to avoid timezone confusion',
  'sql.bestPractice2': 'Index timestamp columns used frequently in WHERE clauses for better performance',
  'sql.bestPractice3': 'Use database-native functions instead of converting in application code when possible',
  'sql.bestPractice4': 'Be aware of the Year 2038 Problem when using 32-bit integer timestamps',
  'sql.bestPractice5': 'Use BIGINT for millisecond timestamps to avoid overflow issues',
};
